import './App.css';
import { Route } from 'react-router-dom';
import { Routes } from './constants/routes.js';
import { BrowserRouter as Router } from 'react-router-dom';

import Navbar from './components/nav/navbar';
import Title from './components/title';
import Footer from './components/footer';

function App() {
	return (
		<Router>
			<div className='App'>
				<Title />
				<Navbar />
				{Routes.map((v) => (
					<Route
						key={v.path}
						exact={v.isExact}
						path={v.path}
						render={() => {
							window.scrollTo(0, 0);
							return v.component;
						}}
					/>
				))}
				<Footer />
			</div>
		</Router>
	);
}

export default App;
